import { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { DaymapThemeProvider, Page, Button, Section, Loading } from 'daymap-library';

import styles from  './App.module.scss';

import Home from './views/Home/Home';
import Kiosk from './views/Kiosk/Kiosk';
import Visitors from './views/Visitors/Visitors';
import Checkin from './views/CheckIn/CheckIn';
import ScheduledEvents from './views/ScheduledEvents/ScheduledEvents';
import Room from './views/Room/RoomMode';
import AppHeader from './components/AppHeader/AppHeader';
import { useAuth } from './helpers/authContext';

const router = createBrowserRouter([
  { 
    path: "/auth",
    element: <></>,
  },
  {
    path: "/",
    element: <Home/>,
  },
  {
    path: "/kiosk/*",
    element: <Kiosk />,
  },
  {
    path: "/visitors/*",
    element: <Visitors />
  },
  {
    path: "/checkin/*",
    element: <Checkin />
  },
  {
    path: "/events/:calendarId/*",
    element: <ScheduledEvents />
  },
  {
    path: "/room/:roomId/*",
    element: <Room />
  }
], { basename: '/kiosk' });

const getTheme = async () => {
  let checkinUrl = `${window.location.origin}/kiosk/auth`
        if (process.env.REACT_APP_CHECKIN_URL)
            checkinUrl = `${process.env.REACT_APP_CHECKIN_URL}/auth`;
  const response = await fetch(`${ process.env.REACT_APP_LMS_API_ORIGIN ? process.env.REACT_APP_LMS_API_ORIGIN : '' }/lms/api/theme/default?redirectUri=${encodeURI(checkinUrl)}`);
  const theme = await response.json();
  return theme;
}

function App() {
  const { isAuthenticated, isSigningOut, clientSettings } = useAuth();

  // apply the zoom setting
  useEffect(() => {
      var multiplier = clientSettings.zoomAmount / 100;
      var root = document.querySelector("html");
      root.style.fontSize = (multiplier*10)+'pt';

      // set width css propert
      const startWidth = 900;
      const newWidth = startWidth  * multiplier;
      document.documentElement.style.setProperty('--display-max-width', `${newWidth}px`);
  }, [clientSettings.zoomAmount]);

  return (
    <DaymapThemeProvider applyTo="none" themeRequest={getTheme}>
      <div className={styles.Main}>
        <AppHeader />
        {!isSigningOut && isAuthenticated && <RouterProvider router={router} />}
        {!isAuthenticated || isSigningOut && <Page center>
            <Section>
              <Loading message={isSigningOut ? 'Signing Out' : 'Logging in please wait'}></Loading>
            </Section>
          </Page>
        }
      </div>
    </DaymapThemeProvider>
  )
}

export default App;
